// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import React, { FC, PropsWithChildren, useState } from "react";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";

export interface CardListStyles {
    gridContainer?: GridContainerProps;
    // XNG-Changes
    gridViewStyledWrapper?: InjectableCss;
}

export const cardListStyles: CardListStyles = {
    gridContainer: {
        gap: 40,
    },
};

const CardList: FC<
    PropsWithChildren<{
        extendedStyles?: CardListStyles;
        css?: StyledProp;
        // XNG-Changes
        isGridView: boolean;
    }>
> = ({ extendedStyles, children, ...otherProps }) => {
    const [styles] = useState(() => mergeToNew(cardListStyles, extendedStyles));
    // XNG-Changes: Added StyledWrapper for Grid View
    return (
        <>
            {otherProps.isGridView ? (
                <StyledWrapper {...styles.gridViewStyledWrapper}>{children}</StyledWrapper>
            ) : (
                <GridContainer {...styles.gridContainer} {...otherProps}>
                    {children}
                </GridContainer>
            )}
        </>
    );
};

export default CardList;
